import { render, staticRenderFns } from "./r-select-option.vue?vue&type=template&id=c38faee6&scoped=true&"
import script from "./r-select-option.vue?vue&type=script&lang=js&"
export * from "./r-select-option.vue?vue&type=script&lang=js&"
import style0 from "./r-select-option.vue?vue&type=style&index=0&id=c38faee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38faee6",
  null
  
)

export default component.exports